module.exports = __webpack_public_path__ + "media/images/global/projects/world-to-students-00e5196c0724736ea8a69feab39b5d9a.png";